var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"editor"}),_c('div',{staticStyle:{"height":"20px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }